import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { ShareRecord } from "../../domain/ShareRecord";

const HTTP_NOT_FOUND = 404;
const ORGANISATIONS = "organisations";

export class ShareService extends BaseRemoteService {
  public async get(id: string, opts: Opts): Promise<ShareRecord | null> {
    const url = `${this.apiRoot}/share/${ORGANISATIONS}/${id}`;
    try {
      const response = await super.getRequest<ShareRecord>(url, opts);
      return response;
    } catch (err: any) {
      if (err && err.status === HTTP_NOT_FOUND) {
        return {
          whitelist: [],
        } as ShareRecord;
      }
      throw err;
    }
  }

  public async update(
    id: string,
    share: ShareRecord,
    opts: Opts
  ): Promise<ShareRecord> {
    const url = `${this.apiRoot}/share/${ORGANISATIONS}/${id}`;
    return await this.putRequest<ShareRecord>(url, share, opts);
  }
}
